/** Ворота 3×3: ряд (T — верх, M — середина, B — низ) и колонка (L, C, R). */
export const ROWS = ['T', 'M', 'B'] as const;
export const COLUMNS = ['L', 'C', 'R'] as const;

export type Row = (typeof ROWS)[number];
export type Column = (typeof COLUMNS)[number];
export type Zone = `${Row}${Column}`;

export const ZONES: readonly Zone[] = ROWS.flatMap((r) => COLUMNS.map((c) => `${r}${c}` as Zone));

export function isZone(value: unknown): value is Zone {
  return typeof value === 'string' && (ZONES as readonly string[]).includes(value);
}

export const rowOf = (zone: Zone): Row => zone[0] as Row;
export const columnOf = (zone: Zone): Column => zone[1] as Column;

/**
 * Насколько вратарь «не угадал»: 0 — та же зона, 1 — соседняя по горизонтали или вертикали, 2 — дальше
 * (в т. ч. по диагонали: прыгнув в угол, центр не достать).
 */
export function zoneDistance(a: Zone, b: Zone): 0 | 1 | 2 {
  const dr = Math.abs(ROWS.indexOf(rowOf(a)) - ROWS.indexOf(rowOf(b)));
  const dc = Math.abs(COLUMNS.indexOf(columnOf(a)) - COLUMNS.indexOf(columnOf(b)));
  return Math.min(dr + dc, 2) as 0 | 1 | 2;
}
